module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/993a0700d8a0972d309307b0a4688ed7.svg";